import { ReactNode } from 'react';

type ProductImageTileProps = Readonly<{
  children: ReactNode;
}>;

export default function ProductImageTile({ children }: ProductImageTileProps) {
  return (
    <div className='flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-md border border-gray-200 bg-white p-1'>
      {children}
    </div>
  );
}
